const VisibilityIcon = (props: { variant?: 'white' | 'black' }) => {
    const name = !props.variant || props.variant === 'white' ? 'visibilityIconWhite.png' : 'visibilityIconBlack.png';
    return (
        <img className="visibility-icon" src={process.env.PUBLIC_URL + "/" + name} alt="Visibility Icon" />
    );
}

export default VisibilityIcon;